import React from 'react';

// Components
import {
    ContentBoxContainer,
    ContentBoxText,
} from 'components';

/* MUI */
import Accordion from '@material-ui/core/Accordion';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

const PageFAQ = ({ title, faqEntries,answerMarginTop, ...props }) => {
    const getHtml = (html) => ({ __html: html });
    const addParagraphTags = (text) => `<p>${text.replace('\n', '</p><p>')}</p>`;

    return (
        <ContentBoxContainer className="single" { ...props }>
            <ContentBoxText className="noTp">
                <h2>{ title }</h2>

                { faqEntries && faqEntries.map((faqEntry) => (
                    <Accordion key={ faqEntry.questionName }>
                        <AccordionSummary
                            expandIcon={ <ExpandMoreIcon /> }
                            aria-controls="panel1a-content"
                            id="panel1a-header"
                        >
                            <h4>{ faqEntry.questionName }</h4>
                        </AccordionSummary>
                        <AccordionDetails>
                            <div style={{ marginTop:answerMarginTop || 0 }} dangerouslySetInnerHTML={ getHtml(addParagraphTags(faqEntry.acceptedAnswerText)) } />
                        </AccordionDetails>
                    </Accordion>
                )) }
            </ContentBoxText>
        </ContentBoxContainer>
    );
};

PageFAQ.defaultProps = {};
PageFAQ.propTypes = {};

export default PageFAQ;
